import useInView from '../../../hooks/useInView';

const reasons = [
  { icon: 'ri-award-line', title: 'Licensed & Insured', desc: 'Every technician is fully licensed, insured, and background-checked before entering your home.' },
  { icon: 'ri-bank-card-line', title: 'Financing Available', desc: '0% APR options, fast approvals, and low monthly payments on all qualifying systems.' },
  { icon: 'ri-time-line', title: 'Fast Installations', desc: 'Most systems installed in one day. Emergency service within hours, not days.' },
  { icon: 'ri-leaf-line', title: 'Energy Efficiency Focus', desc: 'Every recommendation optimizes for long-term energy savings and available rebates.' },
  { icon: 'ri-home-smile-line', title: 'Full-Service Company', desc: 'HVAC, plumbing, electrical, water heaters, insulation. One company, one call.' },
  { icon: 'ri-shield-star-line', title: 'Warranty & Guarantee', desc: 'Full parts and labor warranties on all installations. 100% satisfaction guaranteed.' },
  { icon: 'ri-user-star-line', title: 'Professional Technicians', desc: 'NATE-certified, manufacturer-trained technicians with ongoing education.' },
  { icon: 'ri-star-line', title: '4.9 Customer Rating', desc: 'Thousands of verified 5-star reviews across Google, Yelp, and BBB.' },
];

const stats = [
  { value: '50,000+', label: 'Homes Served' },
  { value: '4.9 / 5', label: 'Avg. Customer Rating' },
  { value: '98%', label: 'Same-Day Completion' },
  { value: 'Florida', label: 'Statewide Coverage' },
];

const WhyChooseUs = () => {
  const { ref: headerRef, inView: headerInView } = useInView();
  const { ref: statsRef, inView: statsInView } = useInView();
  const { ref: cardsRef, inView: cardsInView } = useInView();

  return (
    <section id="why-renova" className="py-10 md:py-16 bg-[#EEF5FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={headerRef}
          className={`text-center mb-10 md:mb-16 transition-all duration-700 ease-out ${headerInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Why Renova</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-4 sm:mb-5">
            Built for Modern Homeowners
          </h2>
          <p className="text-base sm:text-lg text-[#6B7280] max-w-2xl mx-auto">
            Renova is not a small local contractor. We are Florida&apos;s full-service home comfort platform built to deliver consistently excellent experiences across every service category.
          </p>
        </div>

        <div ref={statsRef} className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-10 sm:mb-14">
          {stats.map((s, i) => (
            <div
              key={s.label}
              style={{ transitionDelay: `${i * 100}ms` }}
              className={`bg-white rounded-xl p-4 sm:p-6 text-center border border-[#1A56A0]/20 transition-all duration-700 ease-out ${statsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1A56A0] mb-1 sm:mb-2">{s.value}</p>
              <p className="text-xs sm:text-sm text-[#6B7280]">{s.label}</p>
            </div>
          ))}
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {reasons.map((r, i) => (
            <div
              key={r.title}
              style={{ transitionDelay: `${i * 80}ms` }}
              className={`bg-white rounded-xl p-6 border border-[#E2E8F0] hover:border-[#1A56A0]/40 transition-all duration-500 ease-out ${cardsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-12 h-12 bg-[#1A56A0]/10 rounded-lg flex items-center justify-center mb-5">
                <i className={`${r.icon} text-2xl text-[#1A56A0]`} />
              </div>
              <h3 className="text-base font-bold text-[#111827] mb-2">{r.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
